module.exports = __webpack_public_path__ + "img/ss_spark.c9b83ccd.jpg";